import { useCallback, useState } from "react";
import { ILocationViewModel, IPlacePredictionViewModel } from "Services/API/API";
import usePlaceGeocoder from "Services/Geocoder";
import {
   parsePlaceToAddress,
   PlaceAddressFormat,
} from "Utils/parsePlaceToAddress";

export interface IPlaceSelection {
   placePrediction: IPlacePredictionViewModel;
   details: {
      location: ILocationViewModel;
      addressParts: PlaceAddressFormat;
   } | undefined;
}

interface UsePlacesAddressReturn {
   isLoading: boolean;
   selection: IPlaceSelection | undefined;
   handleSelect: (e: IPlacePredictionViewModel) => void;
}

export const usePlacesAddress = (): UsePlacesAddressReturn => {
   const [isLoading, setIsLoading] = useState(false);
   const [selection, setSelection] = useState<IPlaceSelection>();
   const geocoder = usePlaceGeocoder();

   const handleSelect = useCallback(
      async (placePrediction: IPlacePredictionViewModel) => {
         try {
            setIsLoading(true);
            if (placePrediction?.placeId) {
               const location = await geocoder.getPlaceDetails(placePrediction.placeId);

               if (location) {
                  setSelection({
                     placePrediction: placePrediction,
                     details: {
                        location,
                        addressParts: parsePlaceToAddress(location)
                     }
                  });
               }
               else {
                  setSelection({
                     placePrediction,
                     details: undefined
                  });
               }
            }
         } finally {
            setIsLoading(false);
         }
      },
      [geocoder]
   );

   return {
      isLoading,
      selection,
      handleSelect,
   };
};
